import React from 'react';
import styles from './InstructorHome.module.css';

export default function StartTeamsMeeting({ url, className = '' }) {
  if (!url || !/^https?:\/\//i.test(url)) return null;
  return (
    <a className={`${styles.btn} ${styles.teamsButton} ${className}`} href={url} target="_blank" rel="noopener noreferrer">
      <span className={styles.teamsIcon} aria-hidden="true">T</span>
      Start Teams Meeting
    </a>
  );
}
